// noinspection DuplicatedCode

import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
import { connect } from 'react-redux';
import DialogForm from '@/modules/common/components/DialogForm';
import { withFetch } from '~/hocs/fetch';
import Form from './Form';

const initialValues = {
    offer: '',
    subject: '',
    note: '',
};

const initialErrors = {
    offer: '',
    subject: '',
    note: ''
};

let abortController;

const DialogAdd = (props) => {
    const { offerName } = useParams();

    const [values, setValues] = useState(initialValues);
    const [errors, setErrors] = useState(initialErrors);
    const [fetching, setFetching] = useState(false);

    const getInitialOffer = () => {
        let offer = '';
        if (offerName) {
            props.cfgOffers.every((cfgOffer) => {
                if (cfgOffer.offer_name === offerName) {
                    offer = cfgOffer.id.toString();
                    return false;
                }
                return true;
            });
        }
        return offer;
    };

    const clear = () => {
        setValues(initialValues);
        setErrors(initialErrors);
    };

    useEffect(() => {
        return () => {
            if (abortController) {
                abortController.abort();
            }
        };
    }, []);

    useEffect(() => {
        if (props.open) {
            setValues({...values, 'offer': getInitialOffer()});
        }
    }, [props.open]);

    const handleChange = (prop) => (event) => {
        setValues({...values, [prop]: event.target.value});
    };

    const handleFocus = (prop) => () => {
        setErrors({...errors, [prop]: ''});
    };

    const handleSubmit = (event) => {
        abortController = new AbortController();

        event.preventDefault();
        setFetching(true);
        props.fetch.post('/api/notes/', {...values}, abortController)
            .then(({ok, data}) => {
                if (ok) {
                    clear();
                    props.onOk(data);
                }
                else {
                    let _errors = {...initialErrors};
                    _errors.offer = (data.offer) ? data.offer[0] : '';
                    _errors.subject = (data.subject) ? data.subject[0] : '';
                    _errors.note = (data.note) ? data.note[0] : '';
                    setErrors(_errors);
                }
                setFetching(false);
            })
            .catch((error) => {
                if (error.name !== 'AbortError') {
                    setFetching(false);
                }
            })
            .finally(() => {
                abortController = null;
            });
    };

    const handleClose = () => {
        props.setOpen(false);
        clear();
    };

    return (
        <DialogForm id="notes-dialog-add" title="Добавление заметки" label="Добавить"
                    open={props.open} onClose={handleClose}
                    onSubmit={handleSubmit}
                    disabled={fetching}
        >
            <Form values={values} onChange={handleChange} errors={errors} onFocus={handleFocus}/>
        </DialogForm>
    );
};

DialogAdd.propTypes = {
    open: PropTypes.bool.isRequired,
    setOpen: PropTypes.func.isRequired,
    onOk: PropTypes.func.isRequired,
};

let Component = DialogAdd;
Component = withFetch(Component);

export default connect(
    (state) => ({
        cfgOffers: state.cfg.offers,
    })
)(Component);
